import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import stringContainingInteger from '../../../shared/utils/custom-proptypes/stringContainingInteger';
import { MATERIAL_ICON_ADD } from '../../../shared/common/Button/Icon';
import { Button, ButtonSize, ButtonTheme } from '../../../shared/common/Button';
import i18n from '../../../../i18n';

export default class LibxAddToCollectionButton extends React.Component {
    state = {
        isAdded: false
    };

    render() {
        const labelText = this.state.isAdded
            ? i18n.t('shop.orders.addedToCollection')
            : i18n.t('shop.orders.alreadyInCollection');

        const label = (
            <div className={this.props.className}>
                <strong>{labelText}</strong>
            </div>
        );

        const productGroupId = this.props.productGroupId;

        const onAddToCollectionFunc = isNil(this.props.updateProduct)
            ? () => this.props.onAddToCollection(this.props.product.id)?.catch(() => this.setState({ isAdded: false }))
            : () =>
                  this.props
                      .onAddToCollection(this.props.product.id)
                      .then(() => this.props.updateProduct(this.props.product.id, productGroupId))
                      .catch(() => this.setState({ isAdded: false }));

        // TODO Improve styling of the add button
        const buttonAdd = (
            <Button
                className={this.props.className}
                icon={MATERIAL_ICON_ADD}
                text={i18n.t('shop.orders.addToCollection')}
                onClick={() => {
                    this.setState({ isAdded: true });
                    onAddToCollectionFunc();
                }}
                fullWidth={this.props.fullWidth}
                size={this.props.size ?? ButtonSize.SMALL}
                theme={this.props.theme ?? ButtonTheme.NEUTRAL}
            />
        );

        return this.props.product.alreadyInCollection || this.state.isAdded ? label : buttonAdd;
    }
}

LibxAddToCollectionButton.propTypes = {
    onAddToCollection: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func,
    fetchLibxProduct: PropTypes.func,
    productGroupId: stringContainingInteger,
    fullWidth: PropTypes.bool,
    size: PropTypes.string,
    theme: PropTypes.string,
    className: PropTypes.string
};
